import React from 'react';

import {MunicipalityEnumComponent, ValueMunicipalityEnumComponent} from '@/components/MunicipalityEnumComponent';
import {ProvinceEnumFilterComponent, ProvinceValueEnumFilterComponent} from '@/components/ProvinceEnumFilterComponent';

export const filters = [
  {
    name: 'provinces',
    field: 'address.province',
    // eslint-disable-next-line react/display-name
    render: (props) => <ProvinceEnumFilterComponent {...props}/>,
    // eslint-disable-next-line react/display-name
    renderValue: (props) => <ProvinceValueEnumFilterComponent {...props}/>
  },
  {
    name: 'municipalities',
    search: true,
    type: 'enum',
    field: 'address.municipality',
    // eslint-disable-next-line react/display-name
    renderValue: (props) => <ValueMunicipalityEnumComponent {...props}/>,
    // eslint-disable-next-line react/display-name
    render: (props) => <MunicipalityEnumComponent {...props}/>
  },
  {
    name: 'createdAt',
    field: 'createdAt',
    type: 'dateRange',
  },
];
